
<div class="content">
  <h2 i18n>Welcome to Our Museum</h2>
  <p i18n>Explore our exhibits and enjoy the audio tours.</p>

  <div class="tour-container">
    <app-tour-tile *ngFor="let tour of tours$ | async" [tour]="tour" (deleted)="refreshTours()"></app-tour-tile>
  </div>
</div>

